import React, { FunctionComponent } from 'react';
import cls from '../utils/classnames';
import { COLUMN } from '../utils/classes';
import './_styles.scss';

export interface IColumnProps {
    /**
     * size of column, 12 the max number.
     */
    lg?: number;
    /**
     * optional className to add to wrapper
     */
    className?: string;
    offset?: number,
    style ?: object
}

export const Column: FunctionComponent<IColumnProps> = props => {
    const { lg, className, children, offset = null, style={}} = props;
    const classNames = cls(COLUMN, className, `${COLUMN}-${lg}`, (offset ? `${COLUMN}-offset-${offset}` : ''));
    return <div style={style} className={classNames}>{children}</div>;
};

Column.defaultProps = {
    lg: 12
};



// WEBPACK FOOTER //
// ./src/packages/components/lib/Column/index.tsx